import React, { useState } from "react";
import { Play, Pause } from "lucide-react";
import { MEDIA_IMGS } from "./data";
import { useReducedMotion } from "../../hooks/useMotion";
import { useT } from "./i18n";

export default function MediaStrip() {
  const { t } = useT();
  const reduced = useReducedMotion();
  const [playing, setPlaying] = useState(false);
  const active = playing && !reduced;

  return (
    <section className="bg-[#12271E] py-8" aria-label={t.strip.eyebrow}>
      <div className="mx-auto max-w-6xl px-5">
        <div className="mb-4 flex items-center justify-between">
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#C4A46B]">{t.strip.eyebrow}</p>
          <button data-testid="media-strip-toggle" onClick={() => setPlaying((p) => !p)} disabled={reduced} aria-pressed={active}
            className="inline-flex items-center gap-2 rounded-full border border-white/20 px-4 py-1.5 text-xs font-medium text-white/85 transition-colors hover:bg-white/10 disabled:opacity-40">
            {active ? <Pause className="h-3.5 w-3.5" /> : <Play className="h-3.5 w-3.5" />}
            {reduced ? t.strip.off : active ? t.strip.pause : t.strip.play}
          </button>
        </div>

        <div className="no-scrollbar snap-x-mandatory flex gap-4 overflow-x-auto pb-1">
          {MEDIA_IMGS.map((img, i) => (
            <figure key={i} className={`kb snap-start relative h-56 w-[78%] shrink-0 overflow-hidden rounded-2xl sm:h-64 sm:w-[44%] lg:w-[30%] ${active ? "playing" : ""}`}>
              <img src={img} alt={t.strip.labels[i]} loading="lazy" decoding="async" className="kb-img h-full w-full object-cover"
                style={active ? { animationDelay: `${i * 1.5}s` } : undefined} />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
              <figcaption className="absolute bottom-3 left-4 text-sm font-medium text-white drop-shadow">{t.strip.labels[i]}</figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
